// Scroll-reveal. CSS keeps everything visible by default; only once we know
// this can run do we flip html.js-ready to hand off to the animation, so a
// JS failure or a missed trigger can never leave content stuck invisible.
const revealEls = document.querySelectorAll(".reveal, .reveal-stagger");

document.documentElement.classList.add("js-ready");

function revealNow(el) {
  el.classList.add("is-visible");
}

if ("IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealNow(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: "0px 0px -5% 0px" }
  );
  revealEls.forEach((el) => io.observe(el));

  // Elements already in view when the observer attaches don't always get an
  // immediate callback in every environment — check once on the next frame.
  requestAnimationFrame(() => {
    revealEls.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) revealNow(el);
    });
  });
} else {
  revealEls.forEach(revealNow);
}

// Belt-and-suspenders: reveal everything shortly after load regardless.
setTimeout(() => revealEls.forEach(revealNow), 1500);

// Product card color swatches — small colored chips for products with 2+ colors
const CARD_COLOR_HEX = {
  "Noir": "#161511", "Black": "#161511",
  "Clair": "#ede8dd", "Blanc": "#f5f3ee", "White": "#f5f3ee",
  "Gris": "#9c9791", "Grey": "#9c9791", "Gray": "#9c9791",
  "Beige": "#c9ad87",
  "Marine": "#1f2c42", "Navy": "#1f2c42",
  "Vert": "#2e5b3e", "Green": "#2e5b3e",
  "Bleu": "#4fb8d9", "Blue": "#4fb8d9"
};
document.querySelectorAll(".card__swatch-chip[data-color]").forEach((chip) => {
  chip.style.background = CARD_COLOR_HEX[chip.dataset.color] || "#ccc";
});

// Sticky header shrink + tint on scroll
const header = document.querySelector(".site-header");
let lastY = window.scrollY;

window.addEventListener(
  "scroll",
  () => {
    const y = window.scrollY;
    header.classList.toggle("is-scrolled", y > 40);
    lastY = y;
  },
  { passive: true }
);

